module.exports = __webpack_public_path__ + "lp/img/language-darkgray.b66b3781.svg";